import Header from './components/header/Header';
import Catalog from './components/catalog/Catalog';

function App() {
  return (
    <>
      <Header />
      <Catalog></Catalog>
    </>
  );
}

export default App;
